import graphql__56daa97cd178176dab6e from "./__generated__/ContributionsDatavizGraph_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { Outlet } from "react-router";

import ContributionsDatavizRootLayout from "./ContributionsDatavizRootLayout";
import ContributionsDatavizGraphAnimation from "./ContributionsDatavizGraphAnimation";

const ContributionsDatavizGraph = props => {
  const participativeModule = useFragment(
    ContributionsDatavizGraph_participativeModule,
    props.participativeModule
  );

  return (
    <ContributionsDatavizRootLayout
      participativeModule={participativeModule}
      graphViewActive
    >
      <ContributionsDatavizGraphAnimation participativeModule={participativeModule} />

      <Outlet />
    </ContributionsDatavizRootLayout>
  );
};

const ContributionsDatavizGraph_participativeModule = graphql__56daa97cd178176dab6e;

export default ContributionsDatavizGraph;
